var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cross-Chain_icon",
    "data-name": "Cross-Chain icon",
    transform: "translate(0 48) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 48,
    height: 48,
    rx: 13,
    transform: "translate(0 48) rotate(-90)",
    fill: "currentColor",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(9.411 40.611) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M16.769,16.1a1.618,1.618,0,0,0,1.145-2.763L7.826,3.248l7.241.01h0a1.618,1.618,0,0,0,0-3.237L0,0,15.625,15.625A1.614,1.614,0,0,0,16.769,16.1Z",
    transform: "translate(0 13.003) rotate(-45)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1.618,16.1A1.618,1.618,0,0,1,.474,13.337L10.563,3.248l-7.241.01a1.618,1.618,0,0,1,0-3.237L18.388,0,2.763,15.625A1.613,1.613,0,0,1,1.618,16.1Z",
    transform: "translate(22.705 29.242) rotate(-135)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossChain);
export default __webpack_public_path__ + "static/media/cross-chain.fafe8e10.svg";
export { ForwardRef as ReactComponent };